import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { ChartJSChart, Charts } from "../../../Constant";
import BarChart from "./BarChart";
import LineGraph from "./LineGraph";
import RadarGraph from "./RadarGraph";
import LineChart from "./LineChart";
import DoughnutChart from "./DoughnutChart";
import PolarChart from "./PolarChart";

const ChartJSContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={ChartJSChart} parent={Charts} title={ChartJSChart} />
      <Container fluid>
        <Row>
          <BarChart />
          <LineGraph/>
          <RadarGraph />
          <LineChart/>
          <DoughnutChart/>
          <PolarChart/>
        </Row>
      </Container>
    </>
  );
};

export default ChartJSContainer;
